<h1>Compare models</h1>
<p class="muted">Send one prompt to 2–6 models and see their answers side by side.</p>

<form (submit)="$event.preventDefault(); send()">
  <textarea
    name="prompt"
    placeholder="Your prompt"
    aria-label="Prompt"
    [value]="prompt()"
    (input)="prompt.set($any($event.target).value)"
  ></textarea>
  <div class="models">
    @for (pick of rows(); track $index; let i = $index) {
      <div class="pick">
        <span>Model {{ i + 1 }}</span>
        <select
          [attr.aria-label]="'Model ' + (i + 1)"
          (change)="setFamily(i, $any($event.target).value)"
        >
          <option value="" [selected]="!pick">{{ pick ? 'None' : 'Choose a model' }}</option>
          @for (f of families(); track f.name) {
            <option
              [value]="f.name"
              [selected]="pick && family(pick) === f.name"
              [disabled]="
                !(pick && family(pick) === f.name) &&
                f.models.every((m) => takenElsewhere(i).has(m.name))
              "
            >
              {{ f.name }}{{ f.models.some((m) => m.nodes > 0) ? '' : ' (offline)' }}
            </option>
          }
        </select>
        @if (pick) {
          <select
            [attr.aria-label]="'Model ' + (i + 1) + ' size'"
            (change)="setModel(i, $any($event.target).value)"
          >
            @for (m of sizesOf(family(pick)); track m.name) {
              <option
                [value]="m.name"
                [selected]="m.name === pick"
                [disabled]="takenElsewhere(i).has(m.name)"
              >
                {{ size(m.name) }}
                @if (m.nodes > 0) {
                  ({{ m.nodes }} {{ m.nodes === 1 ? 'node' : 'nodes' }})
                } @else {
                  (offline)
                }
              </option>
            }
          </select>
        }
      </div>
    }
  </div>
  @if (error()) {
    <div class="notice error">{{ error() }}</div>
  }
  <button type="submit" class="primary" [disabled]="!canSend() || sending()">
    Compare {{ selected().length || '' }} models
  </button>
</form>

@if (history.value().length) {
  <h2>Previous comparisons</h2>
  <ul>
    @for (h of history.value(); track h.id) {
      <li>
        <a [routerLink]="['/m', h.id]">{{ h.prompt }}</a>
        <span class="small muted">{{ h.created | date: 'medium' }}</span>
      </li>
    }
  </ul>
}
